var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"pull-right"}),_c('div',[_c('strong',[_vm._v("ОКО")]),_vm._v(" © "+_vm._s(new Date().getFullYear())+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }